"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagersService = void 0;
class ManagersService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns information about managers in bulk
     * @param ids
     * @param requestBody
     * @returns ManagersResponse
     * @throws ApiError
     */
    getManagersBulk(ids, requestBody) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/managers',
            query: {
                'ids': ids,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.ManagersService = ManagersService;
